// The four flagship products mapped onto sequential stages of the physical
// supply chain. Single source of truth for the stage order/copy used by the
// homepage hero (app list) and the SupplyChainStages section (Home + Solutions).

export interface SupplyChainStage {
  slug: 'openrfq' | 'ainventory' | 'atracker' | 'supplymd';
  title: string;
  icon: 'source' | 'receive' | 'assets' | 'dispense';
  description: string;
}

export const supplyChainStages: SupplyChainStage[] = [
  {
    slug: 'openrfq',
    title: 'Source',
    icon: 'source',
    description: 'Request quotes, compare supplier pricing, and award business — all from your phone.',
  },
  {
    slug: 'ainventory',
    title: 'Receive & Track',
    icon: 'receive',
    description: 'Scan barcodes to receive, transfer, and count inventory across warehouses in real time.',
  },
  {
    slug: 'atracker',
    title: 'Track Assets',
    icon: 'assets',
    description: 'Check equipment in and out, and track assets across every site your team touches.',
  },
  {
    slug: 'supplymd',
    title: 'Dispense & Use',
    icon: 'dispense',
    description: 'Dispense medical supplies with expiration alerts, batch recalls, and full traceability.',
  },
];
